var exports = {
  "om": "xa15a2ab7--b9ac89--block",
  "l3": "xa15a2ab7--b9ac89--badge-wrap",
  "DD": "xa15a2ab7--b9ac89--title",
  "X5": "xa15a2ab7--b9ac89--title-icon",
  "x3": "xa15a2ab7--b9ac89--list-item",
  "lg": "xa15a2ab7--b9ac89--list-icon",
};

module.exports = exports;
